import { FabiJobSearchQueryGenerationUseCase } from '@xing-com/crate-common-graphql-types';
import { useJobsNwtTracking } from '@xing-com/crate-jobs-tracking';

const USE_CASE_TO_TRACKING: Record<
  FabiJobSearchQueryGenerationUseCase,
  string
> = {
  [FabiJobSearchQueryGenerationUseCase.EarnMore]: 'want_to_earn_more',
  [FabiJobSearchQueryGenerationUseCase.SearchWithProfile]:
    'search_with_my_profile',
  [FabiJobSearchQueryGenerationUseCase.SearchWithSkills]:
    'search_with_my_skills',
};

type UseSuggestionsTrackingResult = (
  useCase: FabiJobSearchQueryGenerationUseCase
) => void;

export const useSuggestionsTracking = (): UseSuggestionsTrackingResult => {
  const trackNwt = useJobsNwtTracking();

  return (useCase) => {
    trackNwt({
      event: 'clicked',
      element: USE_CASE_TO_TRACKING[useCase],
      elementDetail: 'auto_complete_option',
      componentName: 'ai_search',
      eventSchema: 'aicomponent',
      page: 'jobs_search/serp',
    });
  };
};
